import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios";
import { emailVaildation } from "../../_helpers";
import { courseService } from "../../_services";
import TopBar from "../Other/TopBar";
import "./login.scss";
const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMesssage] = useState("");
  const [manageConfirmation, setManageConfirmation] = useState(false);
  const [resendMailValue, setResendmailValue] = useState({});

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSendEmail = (e) => {
    e.preventDefault();
    setValidation(true);
    const ValidateEmail = emailVaildation(email) ? true : false;
    const data = {
      email: email,
    };
    if (ValidateEmail !== false) {
      setResendmailValue(data);
      courseService.profileForgetPassword(data).then((response) => {
        if (response?.data?.error === false) {
          setManageConfirmation(true);
        } else if (response?.data?.error === true) {
          setErrorMesssage(response.data.message);
        }
      });
    }
  };

  return (
    <div>
      <TopBar></TopBar>

      <div>
        <section className="inner_page_breadcrumb"></section>
        <h1 className="centered">Enterprise Login</h1>
      </div>
      <div className="enterprise-form-wrapper">
        {!manageConfirmation ? (
          <>
            <div className="login-form-heading">
              <h3>Login to your account</h3>
            </div>
            <div className="enterprise-login-form">
              <form onSubmit={handleSendEmail}>
                <div>
                  <input
                    placeholder={t("Please enter your email")}
                    aria-label="username"
                    type="text"
                    className={`${
                      email === "" && validation === true && "validate-error"
                    }`}
                    value={email}
                    onChange={handleChange}
                  />
                </div>
                <p className="error-text">
                  {email !== "" &&
                    validation === true &&
                    emailVaildation(email) === false &&
                    "Please enter a valid email"}
                </p>
                <p className="no-data-found">{errorMessage}</p>
                <div className="form-row flex-wrapper ">
                  <button className="cancel-btn">Reset Password</button>
                  <Link to="/" className="cancel-btn">
                    Cancel
                  </Link>
                </div>
              </form>
            </div>
          </>
        ) : (
          <Confirmation resendMailValue={resendMailValue} />
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

export function Confirmation({ resendMailValue }) {
  const [resendNotify, setResendNotify] = useState(false);
  const { t } = useTranslation();

  const handleResendEmail = () => {
    if (resendMailValue) {
      setResendNotify(true);
      axiosInstance.post(`forgot-password`, resendMailValue, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
  };

  return (
    <>
      <div className="right-top">
        <h5>{t("Forgot Password ?")}</h5>
        <div className="finePrnt">
          {t("notRegistered")} <Link to="/register">{t("Signup")}</Link>
        </div>
      </div>
      <div className="form-wrapper">
        <div className="center">
          <div className="form-row">
            <p className="form-text">
              Please check your email for a verification message. Click the link
              in the message to change your password.
            </p>
            <p className="form-text">Thank You !</p>
          </div>

          <div className="form-row flex-wrapper">
            <a
              href="javascript:;"
              onClick={handleResendEmail}
              className="resend-btn"
            >
              {resendNotify
                ? "verification mail send successfully"
                : "Resend verification email "}
            </a>
            <Link to="/login" className="close-btn">
              Close
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
